/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/chain_medium'
export default icon
